(function () {
  'use strict';

  function localeRoot() {
    var shopify = window.Shopify || {};
    var locale = String(shopify.locale || document.documentElement.lang || '').toLowerCase();
    var pathname = window.location.pathname.toLowerCase();
    if (locale && (pathname === '/' + locale || pathname.indexOf('/' + locale + '/') === 0)) return '/' + locale + '/';
    return (shopify.routes && shopify.routes.root) || '/';
  }

  document.querySelectorAll('[data-duo]').forEach(function (block) {
    if (block.dataset.duoReady) return;
    block.dataset.duoReady = 'true';
    var btn = block.querySelector('[data-add-duo]');
    var label = block.querySelector('[data-duo-label]');
    var note = block.querySelector('[data-duo-note]');
    var form = document.getElementById('ProductForm');
    var variants;
    try {
      variants = JSON.parse(block.querySelector('[data-duo-variants]').textContent);
    } catch (_) {
      btn.disabled = true;
      note.textContent = btn.dataset.labelError;
      return;
    }
    var pending = false;
    var doneFor = null;
    var resetTimer;

    function sync() {
      var input = form && form.querySelector('[name="id"]');
      var id = input ? input.value : btn.dataset.currentVariant;
      var variant = variants[id];
      btn.dataset.currentVariant = id;
      if (variant) {
        block.querySelector('[data-duo-price]').textContent = variant.price;
        block.querySelector('[data-duo-total]').textContent = variant.total;
        block.querySelector('[data-duo-variant-title]').textContent = variant.title;
        var image = block.querySelector('[data-duo-image]');
        image.hidden = !variant.image;
        if (variant.image) image.setAttribute('src', variant.image);
        else image.removeAttribute('src');
      }
      var available = Boolean(variant && variant.available);
      var done = doneFor === id && available;
      btn.disabled = pending || !available;
      btn.setAttribute('aria-disabled', String(btn.disabled));
      btn.classList.toggle('is-done', done && !pending);
      if (pending) btn.setAttribute('aria-busy', 'true');
      else btn.removeAttribute('aria-busy');
      label.textContent = pending ? btn.dataset.labelLoading : !available ? btn.dataset.labelUnavailable : done ? btn.dataset.labelDone : btn.dataset.labelIdle;
    }

    if (form) form.addEventListener('change', function () {
      doneFor = null;
      sync();
    });

    btn.addEventListener('click', async function () {
      if (pending) return;
      sync();
      if (btn.disabled) return;
      var id = btn.dataset.currentVariant;
      pending = true;
      doneFor = null;
      clearTimeout(resetTimer);
      note.textContent = '';
      sync();
      try {
        var response = await fetch(localeRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [
            { id: Number(id), quantity: 1 },
            { id: Number(btn.dataset.partnerVariant), quantity: 1 }
          ] })
        });
        if (!response.ok) throw new Error('duo-add-failed');
        doneFor = id;
        resetTimer = setTimeout(function () { doneFor = null; sync(); }, 2600);
        if (document.querySelector('cart-drawer')) {
          document.dispatchEvent(new CustomEvent('cart:add-success'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } else {
          window.location.href = localeRoot() + 'cart';
        }
      } catch (_) {
        note.textContent = btn.dataset.labelError;
      } finally {
        pending = false;
        sync();
      }
    });
    sync();
  });
})();
